/**
 * Extrae los nombres de ruta Vue (actions.path) del menú anidado del ERP.
 */
export function extraerRutasDesdeMenu(menu) {
  const permisos = []
  if (!Array.isArray(menu)) return permisos

  for (const item of menu) {
    const items = item && item.items ? item.items : []
    for (const cat of items) {
      if (Array.isArray(cat.items) && cat.items.length) {
        for (const child of cat.items) {
          if (child && child.path) permisos.push(child.path)
        }
      } else if (cat && cat.path) {
        permisos.push(cat.path)
      }
    }
  }

  return permisos
}
